import { Currency } from '@/core/currency/interfaces';

const USD: Currency = {
    name: 'United States Dollar',
    demonym: 'US',
    majorSingle: 'Dollar',
    majorPlural: 'Dollars',
    codeNumeric: '840',
    symbol: '$',
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'USD',
    delimiters: {
        thousands: ',',
        decimal: '.'
    }
};

export default USD;
